import { cloneDeep } from 'lodash';

/**
 * @deprecated Use cloneDeep directly from lodash instead.
 */
export const deepClone = cloneDeep;
